<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>
        <v-container fluid>
            <v-simple-table class="mainTable" fixed-header height="75vh">
                <thead>
                    <tr>
                        <!-- <th v-show="editMode" width="20"></th> -->
                        <!-- <th v-show="editMode" width="20">EDIT</th> -->
                        <th> TYPE </th>
                        <th> COLOR </th>
                        <th> HOUSE TYPE </th>
                        <th v-show="viewMode"> CREATED </th>
                        <th v-show="viewMode"> UPDATED </th>
                        <th v-show="viewMode"> CREATED BY </th>
                        <th v-show="viewMode"> UPDATED BY</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(tatami, i) in TATAMI" :key="i">
                        <!-- <td v-show="editMode">
                            <v-checkbox v-model="tatami.selected" dense></v-checkbox>
                        </td> -->
                        <!-- <td v-show="editMode">
                            <v-btn fab small @click="toggleUpdateDialog(tatami)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </td> -->
                        <td>{{ tatami.tatami_type.tatami_type }}</td>
                        <td>{{ tatami.tatami_color.tatami_color }}</td>
                        <!-- <td v-show="viewMode">
                            <v-chip class="mx-1 font-weight-bold" small v-for="(SUBITEM, ii) in tatamihouses.house_type.name" :key="`${i}-${ii}`">
                                {{ SUBITEM.house_type.name }}
                            </v-chip>
                        </td> -->

                        <td>
                            <v-chip 
                                class="mx-1 font-weight-bold" 
                                small 
                                v-for="(subItem, ii) in tatami.tatamihouses" 
                                :key="`${i}-${ii}`"
                            >
                                {{ subItem.house_type ? subItem.house_type.name : '' }}
                            </v-chip>
                        </td>
                        <!-- <td v-show="viewMode"> {{ formatDate(tatami.created_at) }} </td>
                        <td v-show="viewMode"> {{ formatDate(tatami.updated_at) }} </td> -->
                        <td v-show="viewMode"> 
                            {{ tatami.tatamihouses && tatami.tatamihouses[0] ? formatDate(tatami.tatamihouses[0].created_at) : '' }} 
                        </td>
                        <td v-show="viewMode"> 
                            {{ tatami.tatamihouses && tatami.tatamihouses[0] ? formatDate(tatami.tatamihouses[0].updated_at) : '' }} 
                        </td>
                        <td v-show="viewMode"> {{ tatami.tatamihouses && tatami.tatamihouses[0] ? tatami.tatamihouses[0].created_by : '' }} </td>
                        <td v-show="viewMode"> {{ tatami.tatamihouses && tatami.tatamihouses[0] ? tatami.tatamihouses[0].updated_by : ''  }} </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-container>

        <!-- DIALOGS -->
        <!-- ADD DIALOG -->
        <v-dialog v-model="dialogStore" max-width="300" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title>
                        <span class="overline"> Create Tatami</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete v-model="selectedTatamiId" :items="tatamiItems" item-text="tatami_type" item-value="id" outlined dense label="Tatami Type" name="tatami_type_id" class="required" :rules="rules.required"></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete v-model="selectedColorId" :items="filteredColors" item-value="tatami_color_id" item-text="tatami_color" outlined dense label="Tatami Color" name="tatami_color_id" class="required" :rules="rules.required"></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete :items="HOUSE_TYPES" item-value="id" item-text="name" outlined multiple label="House Type" name="house_type_id" class="required" :rules="rules.required" chips small-chips deletable-chips></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogStore = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <!-- EDIT DIALOG -->
        <v-dialog v-model="dialogUpdate" max-width="300" persistent>
            <v-form id="Update" ref="Update" @submit.prevent="Update">
                <v-card>
                    <v-card-title>
                        <span class="overline">Edit Tatami</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete item-text="tatami_type" item-value="id" :items="tatamiItems"  v-model="selectedTatamiId" outlined dense label="Tatami Type" name="tatami_type" class="required" :rules="rules.required"></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete item-value="tatami_color_id" item-text="tatami_color" :items="filteredColors" v-model="selectedColorId" outlined dense label="Tatami Color" name="tatami_color" class="required" :rules="rules.required"></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete v-model="tempData.house_type_id" :items="HOUSE_TYPES" item-value="id" item-text="name" outlined multiple label="House Type" name="house_type_id" class="required" :rules="rules.required" chips small-chips></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogUpdate = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <app-buttons
            @toggleDialogStore="toggleDialogStore"
            :selectedData="selectedData"
            :floatButtons="floatButtons">
        </app-buttons>
        <app-footer :items="TATAMI.length"></app-footer>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import Footer from '../../modules/Footer.vue';
import FloatingButtons from '../../modules/FloatingButtons.vue';

export default {
    components: {
        'app-toolbar': ToolbarMenu,
        'app-buttons': FloatingButtons,
        'app-footer': Footer
    },

    data: () => ({
        selectedColorId: null,
        selectedTatamiId: null,
        tatamiData: [], 
        tatamiItems: [],
        toolbar: {
            title: "TATAMI (畳)",
            view: true,
            back: true,
            filter: false,
            master: false
        },

        floatButtons: {
            add: true,
            update: false,
            delete: true
        },

        tempData: {},

        dialogStore: false,
        dialogUpdate: false,
    }),

    computed : {
        ...mapState([
            'TATAMI',
            'HOUSE_TYPES',
            'rules',
            'viewMode',
            'editMode'
        ]),

        selectedData(){
            return this.TATAMI.filter(res => res.selected).map(res => res.id);
        },

        filteredColors() {
            if (!this.selectedTatamiId) return [];
            const selectedItem = this.tatamiData.find(item => item.id === this.selectedTatamiId);
            if (!selectedItem) return [];

            return this.tatamiData.filter(item => item.tatami_type === selectedItem.tatami_type);
        }
    }, 

    methods : {
        ...mapActions([
            '_getTatamiDetails',
            '_getHouseTypes',
        ]),

        // toggleDialogDelete(val){
        //     console.log(val);
        //     this.dialogDelete = val;
        // },

        Delete(){
            axios({
                method: 'POST',
                url: '/api/hp_stairs/delete',
                data: {ids : this.selectedData}
            }).then(() => {
                this._getHpStair();
                this.dialogDelete = false;
            })
        },

        toggleUpdateDialog(item){
            if(item){
                this.selectedTatamiId = item.tatami_type.tatami_type_id;
                this.selectedColorId = item.tatami_color.tatami_color_id;
                this.tempData.house_type_id = item.tatamihouses.map(res => res.house_type.id);
                this.dialogUpdate = true;
            }else{
                this.selectedTatamiId = null;
                this.selectedColorId = null;
                this.tempData.house_type_id = null;
                this.dialogUpdate = false;
            }
        },

        Update(){
            if(this.$refs.Update.validate()) {
                const myForm = document.getElementById('Update');
                const formdata = new FormData(myForm);
                const id = this.tempData.id;

                axios({
                    method: 'POST',
                    url: '/api/updateTatamiHouseType/',
                    data:  formdata
                }).then(() => {
                    this._getHpStair();
                    this.$refs.Update.resetValidation();
                    this.$refs.Update.reset();
                    this.dialogUpdate = false;
                })
            }
        },

        Store(){
            if(this.$refs.Store.validate()) {
                const myForm = document.getElementById('Store');
                const formdata = new FormData(myForm);


                axios({
                    method: 'post',
                    url: '/api/storeInTatamiHouseType',
                    data: formdata
                }).then(() => {
                    this._getTatamiDetails();
                    this.$refs.Store.resetValidation();
                    this.$refs.Store.reset();
                    this.dialogStore = false;
                })
            }
        },

        formatDate(val) {
            return new Date(val).toLocaleString('en-US', { timeZone: 'Asia/Manila', hour12: false});
        },

        toggleDialogStore(val) {
            this.dialogStore = val;
        },

    },

    mounted() {
        this._getTatamiDetails().then(() => {
            this._getHouseTypes();
        })

        axios({
            method: 'get',
            url: '/api/getTatamiType'
        }).then((res) => {
            this.tatamiData = res.data;

            this.tatamiItems = Array.from(
                new Map(res.data.map(item => [item.tatami_type, { id: item.id, tatami_type: item.tatami_type }])).values()
            );

        })
    }
}
</script>
<style scoped>
</style>